import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FamilyResponseDto, FamilyBoardMemberDto, FamilyExecutiveMemberDto } from '../../models/api/companyFamilyDto';
import { FamilyUpsertRequest } from '../../models/api/companyFamilyRequest';
import { YearlyResource } from '../../models/api/yearlyResource';

export interface FamilyContext {
  boardType?: number;
  founder1?: string;
  founder2?: string;
  founder3?: string;
  founder4?: string;
  founder5?: string;
  yearOfFounding?: string | null;
  yearWentPublic?: string | null;
  boardMembers: FamilyBoardMemberDto[];
  executiveMembers: FamilyExecutiveMemberDto[];
}

@Injectable({
  providedIn: 'root'
})
export class CompanyFamilyService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  get(companyId: string, year?: number): Observable<YearlyResource<FamilyResponseDto, FamilyContext>> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<YearlyResource<FamilyResponseDto, FamilyContext>>(
      `${this.apiUrl}/${companyId}/family`,
      { params }
    );
  }

  upsert(companyId: string, request: FamilyUpsertRequest): Observable<YearlyResource<FamilyResponseDto, FamilyContext>> {
    return this.http.put<YearlyResource<FamilyResponseDto, FamilyContext>>(`${this.apiUrl}/${companyId}/family`, request);
  }
}
